import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import Label from "@/Components/Label";
import LoadingButton from "@/Components/LoadingButton";
import PageHeading from "@/Components/PageHeading";
import TextInput from "@/Components/TextInput";
import DateInput from "@/Components/DateInput";
import MultiSelectInput from "@/Components/MultiSelectInput";
import { Inertia } from "@inertiajs/inertia";

const breadcrumb = [
    { name: "Dashboard", route: route("dashboard") },
    { name: "Student", route: route("students") },
    { name: "Edit", route: null },
];

const Edit = () => {
    const { student, groups } = usePage().props;

    const {
        data,
        setData,
        errors,
        put,
        delete: destroy,
        processing,
        clearErrors,
        transform,
    } = useForm({
        name: student.name || "",
        contact: student.contact || "",
        registration_no: student.registration_no || "",
        identification_no: student.identification_no || "",
        dob: student.dob || "",
        groups: _.intersectionWith(groups, student.groups, _.isEqual) || [],
    });

    transform((data) => {
        return {
            ...data,
            groups: _.map(data.groups, "id"),
        };
    });

    function handleSubmit(e) {
        e.preventDefault();
        put(route("students.update", student.id));
    }

    function handleDelete(e) {
        e.preventDefault();
        destroy(route("students.delete", student.id), {
            onBefore: () => confirm("Are you sure you want to delete?"),
        });
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("students"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Edit Student"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg rounded-md bg-white px-4 py-10 pb-12 shadow lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label name={"name"} label={"Student Name"} />
                                <TextInput
                                    id={"name"}
                                    name={"name"}
                                    onChange={(e) =>
                                        setData("name", e.target.value)
                                    }
                                    value={data.name}
                                    errors={errors.name}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"contact"}
                                    label={"Contact Number"}
                                />
                                <TextInput
                                    id={"contact"}
                                    name={"contact"}
                                    onChange={(e) =>
                                        setData("contact", e.target.value)
                                    }
                                    errors={errors.contact}
                                    value={data.contact}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"registration_no"}
                                    label={"Registration Number"}
                                />
                                <TextInput
                                    id={"registration_no"}
                                    name={"registration_no"}
                                    onChange={(e) =>
                                        setData(
                                            "registration_no",
                                            e.target.value
                                        )
                                    }
                                    errors={errors.registration_no}
                                    value={data.registration_no}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"identification_no"}
                                    label={"Identification Number"}
                                />
                                <TextInput
                                    id={"identification_no"}
                                    name={"identification_no"}
                                    onChange={(e) =>
                                        setData(
                                            "identification_no",
                                            e.target.value
                                        )
                                    }
                                    errors={errors.identification_no}
                                    value={data.identification_no}
                                />
                            </div>
                            <div>
                                <Label name={"dob"} label={"Date of Birth"} />
                                <DateInput
                                    id={"dob"}
                                    name={"dob"}
                                    onChange={(e) =>
                                        setData("dob", e.target.value)
                                    }
                                    errors={errors.dob}
                                    value={data.dob}
                                />
                            </div>
                            <div>
                                <MultiSelectInput
                                    items={groups}
                                    selected={data.groups}
                                    setSelected={(e) => setData("groups", e)}
                                    multiple={true}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-between">
                                <div className="">
                                    <LoadingButton
                                        type={"button"}
                                        loading={processing}
                                        className={
                                            "bg-red-600 font-medium text-white"
                                        }
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </LoadingButton>
                                </div>
                                <div className={"flex justify-end space-x-1"}>
                                    <LoadingButton
                                        type={"button"}
                                        onClick={handleCancel}
                                        loading={processing}
                                        className={"btn-secondary"}
                                    >
                                        Cancel
                                    </LoadingButton>
                                    <LoadingButton
                                        type={"submit"}
                                        loading={processing}
                                        className={"btn-primary"}
                                    >
                                        Update
                                    </LoadingButton>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        // <div className="w-full">
        //     <main>
        //         <div className="p-4 bg-white block sm:flex items-center justify-between border-b border-gray-200">
        //             <div className="mb-1 w-full">
        //                 <div className="mb-4">
        //                     <BreadCrumb
        //                         links={[
        //                             {name: 'Home', route: 'dashboard'},
        //                             {name: 'Students', route: 'students'},
        //                             {name: 'Edit', route: null}
        //                         ]}
        //                     />
        //                     <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">Students</h1>
        //                 </div>
        //                 <div className="sm:flex">
        //                     <div className="flex items-center space-x-2 sm:space-x-3 mr-auto">
        //                         <Link
        //                             className={"w-1/2 text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-cyan-200 font-medium inline-flex items-center justify-center rounded-lg text-sm px-3 py-2 text-center sm:w-auto"}
        //                             href={route('students')}
        //                         >
        //                             <svg xmlns="http://www.w3.org/2000/svg" className="-ml-1 mr-2 h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
        //                                 <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
        //                             </svg>
        //                             Back
        //                         </Link>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="p-4 flex items-center justify-center border-b border-gray-200">
        //             <div className="p-6 w-1/3 shadow">
        //                 <form onSubmit={handleSubmit}>
        //                     <div className="mb-6">
        //                         <Label label={"Student Name"} name={"name"} />
        //                         <Input
        //                             type={"text"} className={"block w-full mt-2"} name={"name"}
        //                             placeholder={"Jon Doe"}
        //                             onChange={e => setData('name', e.target.value)}
        //                             errors={errors.name}
        //                             onFocus={() => clearErrors('name')}
        //                             value={data.name}
        //                         />
        //                     </div>
        //                     <div className="mb-6">
        //                         <Label label={"Contact No"} name={"contact"}/>
        //                         <Input
        //                             type={"text"} className={"block w-full mt-2"} name={"contact"}
        //                             placeholder={"Jon Doe"}
        //                             onChange={e => setData('contact', e.target.value)}
        //                             errors={errors.contact}
        //                             onFocus={() => clearErrors('contact')}
        //                             value={data.contact}
        //                         />
        //                     </div>
        //                     <div className="mb-6">
        //                         <Label label={"Registration No"} name={"registration_no"}/>
        //                         <Input
        //                             type={"text"} className={"block w-full mt-2"} name={"registration_no"}
        //                             placeholder={"Jon Doe"}
        //                             onChange={e => setData('registration_no', e.target.value)}
        //                             errors={errors.registration_no}
        //                             onFocus={() => clearErrors('registration_no')}
        //                             value={data.registration_no}
        //                         />
        //                     </div>
        //                     <div className="mb-6">
        //                         <Label label={"Identification No"} name={"identification_no"}/>
        //                         <Input
        //                             type={"text"} className={"block w-full mt-2"} name={"identification_no"}
        //                             placeholder={"Jon Doe"}
        //                             onChange={e => setData('identification_no', e.target.value)}
        //                             errors={errors.identification_no}
        //                             onFocus={() => clearErrors('identification_no')}
        //                             value={data.identification_no}
        //                         />
        //                     </div>
        //                     <div className="flex items-center mt-4">
        //                         <button
        //                             className="text-red-600 focus:outline-none hover:underline"
        //                             tabIndex={-1}
        //                             type="button"
        //                             onClick={handleDelete}
        //                         >
        //                             Delete Student ?
        //                         </button>
        //                         <LoadingButton
        //                             loading={processing}
        //                             type={"submit"}
        //                             className={"ml-auto btn-primary"}
        //                         >
        //                             Update
        //                         </LoadingButton>
        //                     </div>
        //                 </form>
        //             </div>
        //         </div>
        //     </main>
        // </div>
    );
};

Edit.layout = (page) => <Authenticated children={page} />;

export default Edit;
